export const ExternalDepartmentTypeText = {
  PAYABLES: 'Payables',
  RECEIVABLES: 'Receivables',
};
